export { Artwork, type ArtworkComponentProps } from './Artwork';
